import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { FocusLock } from "@components/FocusLock";
import { useOnClickOutside } from "./hooks/useOnClickOutside";
import styles from "./modal.module.css";

export function Modal({ isShown, hide, children, ariaLabel }) {
  // Create a ref that we add to the element for which we want to detect outside clicks
  const ref = useRef(null);
  // Call hook passing in the ref and a function to call on outside click
  useOnClickOutside(ref, () => hide());

  useEffect(() => {
    isShown ? (document.body.style.overflow = "hidden") : (document.body.style.overflow = "unset");
    document.addEventListener("keydown", onKeyDown, false);
    return () => {
      document.removeEventListener("keydown", onKeyDown, false);
    };
  }, [isShown]);

  const onKeyDown = (event) => {
    if (event.key === "Escape" && isShown) {
      hide();
    }
  };

  const modal = (
    <>
      <div className={styles.backdrop} />
      <FocusLock>
        <aside
          aria-modal
          aria-labelledby={ariaLabel}
          tabIndex={-1}
          role="dialog"
          ref={ref}
          className={styles.dialog}
        >
          <article className={styles.modal}>{children}</article>
        </aside>
      </FocusLock>
    </>
  );
  return isShown ? ReactDOM.createPortal(modal, document.body) : null;
}
